import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PayperbyteService {

  constructor(public http: HttpClient) { }

  payForCourseRegistration(data){
    return this.http.post<any>('/edozzier/portal-payperbyte-course-payment.php',data);
  }

  computePayment(data){
    return this.http.post<any>('/edozzier/portal-payperbyte-compute-payment.php', data);
  }
}
